import ProfilePage from './ProfilePage';
import {authRoles} from "../../../store/actionreducers/auth/auth";

export const ProfilePageConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: authRoles.user,
    routes  : [
        {
            path     : '/profile',
            component: ProfilePage
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/profile/ProfilePageConfig.js